import { useCallback } from 'react';
import { Toast as ToastType, toast } from 'react-hot-toast';

import { XmarkIcon } from '../../';
import { addStyles } from '../../utils/helpers';
interface ToastProperties {
  children?: React.ReactNode;
  context: ToastType;
  className?: string;
  xmarkClasses?: string;
}

export const Toast = (props: ToastProperties) => {
  const { children, context, className, xmarkClasses } = props;

  const handleClose = useCallback(() => {
    toast.dismiss(context.id);
  }, [context]);

  return (
    <div
      data-testid="toast-wrapper"
      className={addStyles([
        className ?? 'bg-white rounded-lg shadow-dark py-4 px-6 flex gap-12 items-center ',
        context.visible ? 'animate-enter' : 'animate-leave',
      ])}
    >
      {children}
      <button data-testid="toast-dismiss-button" onClick={handleClose}>
        <XmarkIcon className={'size-6 fill-current ' + xmarkClasses} />
      </button>
    </div>
  );
};
export default Toast;
